import React from "react";
import {
  Box,
  Button,
  Popover,
  Stack,
  Typography,
} from "@mui/material";
import HelpOutlineRoundedIcon from "@mui/icons-material/HelpOutlineRounded";

const BRAND = { orange: "#F35A3A", dark: "#19242F" };

export default function ContextualHelp({
  title,
  text,
  bullets = [],
  label = "Ayuda",
  dark = false,
  compact = false,
  buttonSx = {},
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const titleId = React.useId();
  const open = Boolean(anchorEl);

  return (
    <>
      <Button
        type="button"
        size="small"
        variant="text"
        startIcon={<HelpOutlineRoundedIcon sx={{ fontSize: 18 }} />}
        aria-label={`${label}: ${title}`}
        aria-haspopup="dialog"
        aria-expanded={open ? "true" : undefined}
        onClick={(event) => setAnchorEl(event.currentTarget)}
        sx={{
          minWidth: 0,
          px: compact ? 0.75 : 1,
          py: 0.45,
          borderRadius: 999,
          textTransform: "none",
          fontWeight: 900,
          color: dark ? "rgba(255,255,255,.82)" : BRAND.orange,
          bgcolor: dark ? "rgba(255,255,255,.07)" : "rgba(243,90,58,.055)",
          "&:hover": {
            bgcolor: dark ? "rgba(255,255,255,.13)" : "rgba(243,90,58,.11)",
          },
          "& .MuiButton-startIcon": compact
            ? { mr: { xs: 0, sm: 0.5 }, ml: 0 }
            : undefined,
          "&:focus-visible": {
            outline: `2px solid ${dark ? "rgba(255,255,255,.62)" : "rgba(243,90,58,.55)"}`,
            outlineOffset: 2,
          },
          ...buttonSx,
        }}
      >
        <Box component="span" sx={{ display: compact ? { xs: "none", sm: "inline" } : "inline" }}>
          {label}
        </Box>
      </Button>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
        transformOrigin={{ vertical: "top", horizontal: "left" }}
        slotProps={{
          paper: {
            role: "dialog",
            "aria-labelledby": titleId,
            sx: {
              mt: 0.65,
              width: { xs: "calc(100vw - 28px)", sm: 360 },
              maxWidth: 360,
              p: 1.8,
              borderRadius: 3,
              border: "1px solid rgba(25,36,47,.1)",
              boxShadow: "0 18px 48px rgba(25,36,47,.2)",
            },
          },
        }}
      >
        <Stack spacing={1.05}>
          <Typography id={titleId} sx={{ color: BRAND.dark, fontWeight: 950, lineHeight: 1.2 }}>
            {title}
          </Typography>
          {text ? (
            <Typography sx={{ color: "rgba(25,36,47,.66)", fontSize: ".82rem", lineHeight: 1.5 }}>
              {text}
            </Typography>
          ) : null}
          {bullets.length ? (
            <Stack component="ul" spacing={0.65} sx={{ m: 0, pl: 2.1 }}>
              {bullets.map((bullet) => (
                <Box component="li" key={bullet} sx={{ color: "rgba(25,36,47,.68)", pl: 0.15 }}>
                  <Typography component="span" sx={{ fontSize: ".78rem", lineHeight: 1.45 }}>
                    {bullet}
                  </Typography>
                </Box>
              ))}
            </Stack>
          ) : null}
        </Stack>
      </Popover>
    </>
  );
}
